import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { isAuthenticated, isAuthorized } from "@kdose/ng-auth";
import { NextaCanDeactivateCrudForm } from "./../shared/nexta-crud/nexta-can-deactivate.guard";
import { AuthorityFormComponent } from "./authority-form.component";
import { AuthorityListComponent } from "./authority-list.component";

const authorityRoutes: Routes = [
	{
		path: "behoerden",
		component: AuthorityListComponent,
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
	{
		path: "behoerden/neu",
		component: AuthorityFormComponent,
		canDeactivate: [NextaCanDeactivateCrudForm],
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
	{
		path: "behoerden/:id",
		component: AuthorityFormComponent,
		canDeactivate: [NextaCanDeactivateCrudForm],
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
];
@NgModule({
	imports: [RouterModule.forChild(authorityRoutes)],
	exports: [RouterModule],
})
export class AuthorityRoutingModule {}
